import { isBrowser } from "../env-utils/globals.js";
const NOT_IMPLEMENTED = new Error('Not implemented');
export class NodeFileFacade {
  constructor(url, flags, mode) {
    var _globalThis$loaders;
    this.handle = void 0;
    this.size = 0;
    this.bigsize = 0n;
    this.url = '';
    if ((_globalThis$loaders = globalThis.loaders) !== null && _globalThis$loaders !== void 0 && _globalThis$loaders.NodeFile) {
      return new globalThis.loaders.NodeFile(url, flags, mode);
    }
    if (isBrowser) {
      throw new Error('Can\'t instantiate NodeFile in browser.');
    }
    throw new Error('Can\'t instantiate NodeFile. Make sure to import @loaders.gl/polyfills first.');
  }
  async read(start, end) {
    throw NOT_IMPLEMENTED;
  }
  async write(arrayBuffer, offset, length) {
    throw NOT_IMPLEMENTED;
  }
  async stat() {
    throw NOT_IMPLEMENTED;
  }
  async truncate(length) {
    throw NOT_IMPLEMENTED;
  }
  async append(data) {
    throw NOT_IMPLEMENTED;
  }
  async close() {}
}
//# sourceMappingURL=node-file-facade.js.map